import { __decorate } from "tslib";
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { setUserToStorage, setAccountToStorage, removeUserFromStorage, setXHeadersLocale, getStorageXHeaders, removeHeadersFromStorage, } from '@/helpers/auth';
let GlobalStore = class GlobalStore extends VuexModule {
    userData = {};
    account = {};
    editPopupState = false;
    resetPasswordPopupState = false;
    previousScreenName = null;
    mutationLoginUser(userData) {
        setUserToStorage(userData);
        if (userData.authentication_token) {
            setXHeadersLocale(userData);
        }
        const headersData = getStorageXHeaders();
        if (headersData) {
            axios.defaults.headers.common = {
                'X-User-Token': headersData.auth_token,
                'X-User-Email': headersData.auth_email,
            };
        }
        this.userData = userData;
    }
    mutationUnLoginUser() {
        removeUserFromStorage();
        removeHeadersFromStorage();
        delete axios.defaults.headers.common['X-Provider-Toke'];
        delete axios.defaults.headers.common['X-Provider-Name'];
        this.userData = {};
        this.account = {};
    }
    setAccount(account) {
        setAccountToStorage(account);
        this.account = account;
    }
    showResetPasswordPopup(value) {
        this.resetPasswordPopupState = value;
    }
    SET_PREVIOUS_SCREEN_NAME(name) {
        this.previousScreenName = name;
    }
    showEditUserPopup(value) {
        this.editPopupState = value;
    }
    actionUserData(userData) {
        return userData;
    }
    actionUpdateAccountData(account) {
        return account;
    }
    actionUpdateUserData(itemsForUpdate) {
        return { ...this.userData, ...itemsForUpdate };
    }
    get user() {
        return this.userData;
    }
    get isEditPopup() {
        return this.editPopupState;
    }
    get isResetPasswordPopup() {
        return this.resetPasswordPopupState;
    }
};
__decorate([
    Mutation
], GlobalStore.prototype, "mutationLoginUser", null);
__decorate([
    Mutation
], GlobalStore.prototype, "mutationUnLoginUser", null);
__decorate([
    Mutation
], GlobalStore.prototype, "setAccount", null);
__decorate([
    Mutation
], GlobalStore.prototype, "showResetPasswordPopup", null);
__decorate([
    Mutation
], GlobalStore.prototype, "SET_PREVIOUS_SCREEN_NAME", null);
__decorate([
    Mutation
], GlobalStore.prototype, "showEditUserPopup", null);
__decorate([
    Action({ commit: 'setUserData' })
], GlobalStore.prototype, "actionUserData", null);
__decorate([
    Action({ commit: 'setAccount' })
], GlobalStore.prototype, "actionUpdateAccountData", null);
__decorate([
    Action({ commit: 'mutationLoginUser' })
], GlobalStore.prototype, "actionUpdateUserData", null);
GlobalStore = __decorate([
    Module({
        namespaced: true,
    })
], GlobalStore);
export default GlobalStore;
